module.exports = __webpack_public_path__ + "assets/houses.48e87467.svg";